import { StyleSheet } from "react-native";
import { theme } from "../../theme";
import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, } from "../../utils";
export const createGridStyles = (paddingHorizontal, flexWrap, flexDirection) => StyleSheet.create({
    grid: {
        display: "flex",
        flexWrap,
        marginHorizontal: paddingHorizontal !== null ? -theme.spacing[paddingHorizontal] : 0,
        flexDirection,
    },
}).grid;
export const createDefaultCellStyles = (paddingHorizontal, paddingBottom) => StyleSheet.create({
    default: {
        paddingHorizontal,
        paddingBottom,
        flexShrink: 1,
    },
}).default;
export const generateGridCellStyles = (widths) => {
    const responsiveStyles = createResponsiveStyles(Object.entries(widths).reduce((final, [key, width]) => (width ? { ...final, [key]: { width } } : final), {}));
    return ResponsiveStyleSheet.create({
        cell: responsiveStyles,
    });
};
//# sourceMappingURL=FlexGrid.styles.js.map